import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface LegalModalState {
  open: boolean;
  content: string;
  handleOpenModal: (content?: string) => void;
  handleCloseModal: () => void;
}

export const useLegalModalStore = create<LegalModalState>()(
  devtools(
    persist(
      (set) => ({
        open: false,
        content: "",
        handleOpenModal: (content) => set(() => ({ open: true, content })),
        handleCloseModal: () => set(() => ({ open: false, content: "" })),
      }),
      {
        name: "legal-modal-storage",
      },
    ),
  ),
);
